import React, { useEffect, useState } from "react";
import API from "../services/api";

function AIRecommendationCard() {
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    fetchRecommendations();
  }, []);

  const fetchRecommendations = async () => {
    try {
      const res = await API.get("/recommendations");
      setRecommendations(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="card dashboard-card h-100">
      <h5>🧠 AI Recommendations</h5>

      {recommendations.length > 0 ? (
        recommendations.slice(0, 3).map((item) => (
          <div
            key={item.id}
            className="recommendation-item"
          >
            <span
              className={`badge ${
                item.priority === "high"
                  ? "bg-danger"
                  : item.priority === "medium"
                  ? "bg-warning"
                  : "bg-success"
              }`}
            >
              {item.priority}
            </span>

            <p className="mt-2">
              {item.recommendation_text}
            </p>
          </div>
        ))
      ) : (
        <p>No recommendations yet</p>
      )}
    </div>
  );
}

export default AIRecommendationCard;